import { render } from "./BigDay.vue?vue&type=template&id=63a4eb76&scoped=true&ts=true"
import script from "./BigDay.vue?vue&type=script&lang=ts"
export * from "./BigDay.vue?vue&type=script&lang=ts"

import "./BigDay.vue?vue&type=style&index=0&id=63a4eb76&scoped=true&lang=css"

import exportComponent from "/var/www/mmwapp/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a4eb76"]])

export default __exports__